import React from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    buttonProgress: {
        color: theme.palette.secondary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}));

export const MobileButton = ({ label, loading = false, ...rest }) => {
    const classes = useStyles();

    return (
        <Button variant="contained" color="secondary" size="large" disabled={loading} {...rest}>
            {label}
            {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
        </Button >
    )
};

MobileButton.propTypes = {
    label: PropTypes.string
};